import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const MentorsPDF = ({ header, data,title}) => {
  console.log(title);
    
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.title}>
         <Text>{title}</Text>
        </View>

        <View style={styles.table}>
        <View style={styles.tableRow}>
            {header &&
              header.map(value => {
                return (
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{value}</Text>
                  </View>
                );
              })}
          </View>  

          {data &&
            data.map((value,index) => {
               // console.log(value)
              return (
                // <View style={styles.title}>
                //   <Text>{title}</Text>
                // </View>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{index+1}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{value.userName}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{value.mobileNumber}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{value.email}</Text>
                  </View>
                  
                </View>
              );
            })}
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
 
  body: {
    padding: 10
  },
  table: {
    marginTop:'5%',
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '15%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    fontSize:55,
    fontWeight:"bold"
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCellHeader: {
    margin: 'auto',
    fontSize: 12,
    fontWeight: 500
  },
  tableCell: {
    margin: 'auto',
    fontSize: 10
  },
  title:{
  fontSize:19,
  fontWeight:"bold",
  marginLeft:'38%',

  }
});

export default MentorsPDF;
